<template>
  <v-card>
    <v-btn @click="$emit('close')" absolute right class="mt-3" icon>
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-btn class="mr-12 mt-3" style="min-width: auto" absolute right color="primary" small @click="print">
      <v-icon>fas fa-print</v-icon>
    </v-btn>
    <v-card-text id="infoPropertyId">
      <v-card-title><h4 style="word-break: normal; padding-right: 65px">Сведение об имуществе физического лица</h4></v-card-title>
      <column-table v-if="userData" :data="userData" :rows="userDebtHeaders"/>
    </v-card-text>
  </v-card>
</template>

<script>
import ColumnTable from "@/components/ui/table/ColumnTable";
import printTaxInfoMixin from "@/components/calculation/calculator-tax/printTaxInfoMixin";

export default {
  name: 'InfoProperty',
  props: {
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userDebtHeaders: [
        {
          text: 'Область',
          value: 'ns10_code'
        },
        {
          text: 'Район',
          value: 'ns11_code'
        },
        {
          text: 'ИНН',
          value: 'tin'
        },
        {
          text: 'Наименование Физ. Лица',
          value: 'name'
        },
        {
          text: 'Код объекта',
          value: 'obj_code'
        },
        {
          text: 'Наименование объекта',
          value: 'obj_name'
        },
        {
          text: 'Адрес объекта',
          value: 'address'
        },
        {
          text: 'Инвентаризационная стоимость',
          value: 'inv_cost'
        },
        {
          text: 'Общая площадь',
          value: 'total_area'
        },
        {
          text: 'Доля в имуществе',
          value: 'percentage'
        },
        {
          text: 'Общая площадь земли',
          value: 'land_area'
        },
        {
          text: 'Площадь сверх нормы',
          value: 'land_extra_area'
        }
      ]
    }
  },
  components: {ColumnTable},
  mixins: [printTaxInfoMixin('infoPropertyId')]
}
</script>